/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import Pap from "../../../../assets/img/pap.png";

// Afficahge du pap dans la colone d'infos à droite
const PapElement = ({cas}) => {
    const history = useHistory();
    return (
        <>
            {cas.state > 3 &&
                <li onClick={() => history.push(`/pap/${cas.id}`)}>
                    <img src={Pap} alt="plan d'aide personnalisé"/>
                    <div>
                        <h1>Plan d&apos;aide personnalisé</h1>
                        {cas.state < 5 && (
                            <h2>En attente d&apos;acceptation</h2>
                        )}
                        {cas.state == 100 && (
                            <h2>Refusé</h2>
                        )}
                        {cas.state == 5 && (
                            <h2>Accepté</h2>
                        )}
                    </div>
                </li>
            }
        </>
    );
};

PapElement.propTypes = {
    cas: PropTypes.object
};

export default PapElement;
